import { w3cwebsocket } from "websocket";
import { Action } from './store/game';

export class Client {
    private w3cwebsocket: w3cwebsocket;
    private static instance: Client | undefined;

    private constructor(public name: string, public gid: string = "") {
        this.w3cwebsocket = this.initWebsocket();
    }

    static getInstance(name?: string, gid?: string): Client {
        if (!name) return Client.instance!;
        if (!Client.instance) Client.instance = new Client(name, gid);
        return this.instance!;
    }

    private initWebsocket() {
        const client = new w3cwebsocket(`${process.env.VUE_APP_GAME_SERVER_URL}/13clues?name=${this.name}&gid=${this.gid}`);

        client.onerror = () => {
            console.log('Connection Error');
        };

        client.onopen = () => {
            console.log('WebSocket Client Connected');
            this.onopen();
        };

        client.onclose = (e) => {
            console.log('WebSocket Client closed: ' + e.reason);
            this.onclose(e.reason);
        };

        client.onmessage = e => {
            if (typeof e.data === 'string') {
                console.log(JSON.parse(e.data));
                this.onmessage(JSON.parse(e.data));
            }
        };

        (window as any).client = client;
        return client;
    }

    onopen: () => void = () => { }
    onclose: (reason: string) => void = () => { }

    onmessage: (payload: IAction) => void = () => { }

    send<T extends IAction>(payload: T) {
        this.w3cwebsocket.send(JSON.stringify(payload));
    }
}

interface IAction {
    action: Action
}



